



//Debug
// export const baseUrl_back = 'http://127.0.0.1:8000'

//DOCKER
export const baseUrl_back = 'https://api.go-bananas.ru'
// export const baseUrl_back = 'http://172.20.0.4:34321'
// export const baseUrl_back = 'http://95.84.210.60:22004'

